<script setup lang="ts">
// Material Symbols `local_mall`, filled — the Marketplace nav glyph (matches investor-app tab bar). Colour follows CSS `color`.
defineOptions({ inheritAttrs: false })
</script>

<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    v-bind="$attrs"
  >
    <path
      d="M5 21.9994C4.45 21.9994 3.97917 21.8035 3.5875 21.4119C3.19583 21.0202 3 20.5494 3 19.9994V7.99937C3 7.44937 3.19583 6.97854 3.5875 6.58688C3.97917 6.19521 4.45 5.99937 5 5.99937H7C7 4.61604 7.4875 3.43687 8.4625 2.46187C9.4375 1.48687 10.6167 0.999375 12 0.999375C13.3833 0.999375 14.5625 1.48687 15.5375 2.46187C16.5125 3.43687 17 4.61604 17 5.99937H19C19.55 5.99937 20.0208 6.19521 20.4125 6.58688C20.8042 6.97854 21 7.44937 21 7.99937V19.9994C21 20.5494 20.8042 21.0202 20.4125 21.4119C20.0208 21.8035 19.55 21.9994 19 21.9994H5ZM5 19.9994H19V7.99937H5V19.9994ZM12 13.9994C13.3833 13.9994 14.5625 13.5119 15.5375 12.5369C16.5125 11.5619 17 10.3827 17 8.99937H15C15 9.83271 14.7083 10.541 14.125 11.1244C13.5417 11.7077 12.8333 11.9994 12 11.9994C11.1667 11.9994 10.4583 11.7077 9.875 11.1244C9.29167 10.541 9 9.83271 9 8.99937H7C7 10.3827 7.4875 11.5619 8.4625 12.5369C9.4375 13.5119 10.6167 13.9994 12 13.9994ZM9 5.99937H15C15 5.16604 14.7083 4.45771 14.125 3.87437C13.5417 3.29104 12.8333 2.99937 12 2.99937C11.1667 2.99937 10.4583 3.29104 9.875 3.87437C9.29167 4.45771 9 5.16604 9 5.99937Z"
      fill="currentColor"
    />
  </svg>
</template>
